import { INLINES } from '@contentful/rich-text-types';
import { FC } from 'react';

import newsletterSuccess from '@/assets/form-images/form-success.svg';
import Image from '@/components/image';
import RichTextRenderer, {
  renderInlineHyperlink,
} from '@/components/rich-text-renderer';
import getVariablePlainText from '@/lib/get-variable-plain-text';
import useVariables from '@/lib/hooks/use-variables';
import { ImageAsset } from '@/types/views/generic';
import { NewsletterStaticVariant } from '@/types/views/sections';

import getVariantVariableKey from '../../lib/get-variant-variable-key';
import styles from '../first-step/styles';

type SuccessBlockProps = {
  newsletterSuccessImage?: ImageAsset;
  newsletterVariant?: NewsletterStaticVariant;
};

const SuccessBlock: FC<SuccessBlockProps> = ({
  newsletterSuccessImage,
  newsletterVariant = 'newsletter',
}) => {
  const variables = useVariables();
  const successImage = newsletterSuccessImage || newsletterSuccess.src;
  const variantKey = (suffix: string) =>
    getVariantVariableKey(newsletterVariant, suffix);

  const successTitle = getVariablePlainText(
    variables[variantKey('email-success-block-title')],
  );
  const successBody = variables[variantKey('email-success-block-text')];

  return (
    <div className={styles.wrapper}>
      <figure className={styles.imageContainer}>
        <Image
          src={successImage}
          alt={successTitle ?? 'Success subscription to newsletter'}
          objectFit="scale-down"
        />
      </figure>

      <div className={styles.leftSide}>
        <h2 className={styles.heading}>{successTitle}</h2>

        <div className={styles.text}>
          <RichTextRenderer
            className={styles.text}
            body={successBody}
            options={{
              renderNode: {
                [INLINES.HYPERLINK]: renderInlineHyperlink(styles.text),
              },
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default SuccessBlock;
